(function () {
  'use strict';

  var script = document.currentScript;
  var imageProtection = script && script.dataset.imageProtection === 'true';

  function fixPreOrderLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var controls = scope.querySelectorAll('button, input[type="submit"], [role="button"]');

    Array.prototype.forEach.call(controls, function (control) {
      var value = control.tagName === 'INPUT' ? control.value : control.textContent;

      if (value && value.trim().toLowerCase() === 'reserve my dress') {
        if (control.tagName === 'INPUT') {
          control.value = 'Pre-Order';
        } else {
          control.textContent = 'Pre-Order';
        }

        control.setAttribute('data-button-content', 'Pre-Order');
      }
    });
  }

  function protectImages(root) {
    if (!imageProtection) return;

    var scope = root && root.querySelectorAll ? root : document;
    var images = scope.querySelectorAll('img:not([data-ma-allow-copy])');

    Array.prototype.forEach.call(images, function (image) {
      image.setAttribute('draggable', 'false');
    });
  }

  function update(root) {
    fixPreOrderLabels(root);
    protectImages(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    update(document);

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;

      window.requestAnimationFrame(function () {
        queued = false;
        update(document);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  if (imageProtection) {
    document.addEventListener('dragstart', function (event) {
      if (event.target && event.target.closest && event.target.closest('img:not([data-ma-allow-copy])')) {
        event.preventDefault();
      }
    });

    document.addEventListener('contextmenu', function (event) {
      if (event.target && event.target.closest && event.target.closest('img:not([data-ma-allow-copy])')) {
        event.preventDefault();
      }
    });
  }
})();
